// Client API of the multi-tenant package "firmcontact" (server: routes/firmContact.ts, /api/firm-contact).
import { apiRequest, apiBase } from '../api';

export type FirmContactCard = { name: string; phone: string; email: string; website: string; siteHost: string; marketRegion: string };
export type FirmContacts = { legal: FirmContactCard | null; accounting: FirmContactCard | null };
export type FirmAdminCard = FirmContactCard & { leadSites: string[] };   // + the firm's other sites that post website leads
export type MarketCity = { city: string; areas: string[] };

export const firmContactApi = {
  /** No login needed: the DD report's public page prints the firm's contact too. */
  publicContacts: async (): Promise<FirmContacts> => {
    const res = await fetch(`${apiBase()}/firm-contact/public`);
    if (!res.ok) throw new Error('Firm contact unavailable');
    return res.json();
  },
  company: (companyId: string): Promise<FirmAdminCard> => apiRequest('GET', `/firm-contact/company/${companyId}`),
  saveCompany: (companyId: string, data: { marketRegion?: string; leadSites?: string }): Promise<FirmAdminCard> => apiRequest('PUT', `/firm-contact/company/${companyId}`, data),
  marketCities: (): Promise<{ saved: MarketCity[]; effective: MarketCity[] }> => apiRequest('GET', '/firm-contact/market-cities'),
  saveMarketCities: (cities: MarketCity[]): Promise<{ saved: MarketCity[]; effective: MarketCity[] }> => apiRequest('PUT', '/firm-contact/market-cities', { cities }),
};
